module.exports = __webpack_public_path__ + "static/img/12.5450438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/12.png
// module id = caWx
// module chunks = 0